module.exports = "<div #padContainer class=\"padContainer\">\r\n  <signature-pad [options]=\"signaturePadOptions\" class=\"signature-field\"\r\n                 (onBeginEvent)=\"drawStart()\"\r\n                 (onEndEvent)=\"drawComplete()\">\r\n  </signature-pad>\r\n  <button class=\"btn btn-default btn-sm\" (click)=\"clearSignautre()\">\r\n    <span class=\"far fa-trash-alt\" aria-hidden=\"true\"></span>\r\n  </button>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/ui/components/signature/signature.component.html
// module id = ./src/app/core/visbos-core/ui/components/signature/signature.component.html
// module chunks = main